
import { InvoiceDetailsResult } from "@dana/Services/DanaOrderRelatedService";
import { SalseOrgDetails } from "@dana/Services/StandardReturnDetailsService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

// Define the state type for this fetch workflow
export interface DanaInvoiceState {
    isLoading: boolean,
    salseOrgDetails?: SalseOrgDetails,
    data: any,    // Use a more specific type if known
    error: string | null,
}

const initialInvoiceState: DanaInvoiceState = {
    isLoading: false,
    salseOrgDetails: undefined,
    data: null,
    error: null
};

// Create Immer reducer
const danaInvoiceReducer = createTypedReducerWithImmer(initialInvoiceState, {
    // Start loading
    "DanaInvoice/IsLoading": (draft, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        if (action.isLoading) {
            draft.error = null; // Optionally reset error if reloading
        }
    },

    // Populate result on success
    "DanaInvoice/PopulateResult": (draft, action: { data: InvoiceDetailsResult }) => {
        action.data.invoiceDetails = {
            ...action.data.invoiceDetails,
            shipPlantName: action.data.salseOrgDetails.orgName,
            shipPlantAddress1: action.data.salseOrgDetails.orgAddress,
            shipPlantCountry: action.data.salseOrgDetails.country,
        }
        draft.data = action.data.invoiceDetails;

        //  draft.salseOrgDetails = action.data.salseOrgDetails;
        draft.isLoading = false;
        draft.error = null;
    },

    // Handle error
    "DanaInvoice/FetchError": (draft, action: { error: string }) => {
        draft.error = action.error;
        draft.isLoading = false;
    },

    // Reset all state (optional)
    "DanaInvoice/Reset": draft => {
        draft.isLoading = false;
        draft.data = null;
        draft.error = null;
    }
});

// Register reducer in the root
(reducers as any).danaInvoice = danaInvoiceReducer;

// Define type for action usage
type DanaInvoiceReducers = {
    danaInvoice: typeof danaInvoiceReducer;
};

export type DanaInvoiceActions = Parameters<DanaInvoiceReducers[keyof DanaInvoiceReducers]>[1] | AnyAction;
